<template>
  <div v-if="isVisible" class="mpl-banner d-flex align-items-center text-left">
    <svg class="mpl-icon flex-shrink-0 mr-3" viewBox="0 0 24 24" width="22" height="22" fill="none"
      stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
      <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" />
      <circle cx="12" cy="7" r="4" />
    </svg>
    <div class="mpl-content">
      <p class="mb-1 text-14 font-bold">{{ $t('hotel.filter.promotion-link.member-title') }}</p>
      <p class="mb-2 text-12 mpl-desc">{{ $t('hotel.filter.promotion-link.member-desc') }}</p>
      <div class="d-flex flex-wrap mpl-actions">
        <button type="button" class="mpl-btn mpl-btn--primary" @click="openAuth(AUTH_VIEW.LOGIN)">
          {{ $t('hotel.filter.promotion-link.member-login') }}
        </button>
        <button type="button" class="mpl-btn mpl-btn--outline" @click="openAuth(AUTH_VIEW.REGISTER)">
          {{ $t('hotel.filter.promotion-link.member-register') }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex';
  import { AUTH_VIEW } from '@/utils/authQuery.js';

  export default {
    name: 'BeMembershipPromoLoginBanner',
    data() {
      return { AUTH_VIEW };
    },
    computed: {
      ...mapGetters(['getMerchant', 'isLoggedIn', 'isBePromotionFilterMembership']),
      canSignIn() {
        return this.$useCommunityAuth() || this.getMerchant.use_user_menu === true;
      },
      isVisible() {
        return this.isBePromotionFilterMembership && !this.isLoggedIn && this.canSignIn;
      }
    },
    methods: {
      openAuth(view) {
        // the room list was searched as a guest, so the page searches again once signed in
        this.$openAuthModal({ view, onSuccess: () => this.$emit('logged-in') });
      }
    }
  };
</script>

<style scoped>
  .mpl-banner {
    padding: 14px 16px;
    border-radius: 12px;
    border: 1.5px solid var(--merchant-primary-color, #1c2b36);
    background: #fff;
    background: color-mix(in srgb, var(--merchant-primary-color, #1c2b36) 6%, #fff);
  }
  .mpl-icon {
    color: var(--merchant-primary-color, #1c2b36);
  }
  .mpl-content {
    flex: 1;
    min-width: 0;
  }
  .mpl-desc {
    color: #5f6b76;
  }
  .mpl-actions {
    gap: 8px;
  }
  .mpl-btn {
    font-size: 12px;
    font-weight: 600;
    padding: 6px 16px;
    border-radius: 8px;
    border: 1.5px solid var(--merchant-button-color, #1c2b36);
    cursor: pointer;
  }
  .mpl-btn--primary {
    background: var(--merchant-button-color, #1c2b36);
    color: var(--merchant-text-color, #fff);
  }
  .mpl-btn--outline {
    background: #fff;
    color: var(--merchant-button-color, #1c2b36);
  }
</style>



// WEBPACK FOOTER //
// src/components/hotel/be/BeMembershipPromoLoginBanner.vue